export function selectText(node: HTMLOutputElement): void {
  const selection = window.getSelection();
  if (selection === null) {
    return;
  }

  const range = document.createRange();
  range.selectNodeContents(node);
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand('copy');
}
